export class DialogModelSearchByRetailer {
    constructor(
      public code: any
    ) {}
  }
  